__turbopack_context__.v({
  "circleWithDropShadow": "choose-your-plan-v1-module__4SqwjG__circleWithDropShadow",
  "circleWithDropShadowAlt": "choose-your-plan-v1-module__4SqwjG__circleWithDropShadowAlt",
  "circleWithDropShadowInner": "choose-your-plan-v1-module__4SqwjG__circleWithDropShadowInner",
  "entryMethodAllPlansList": "choose-your-plan-v1-module__4SqwjG__entryMethodAllPlansList",
  "entryMethodBadge": "choose-your-plan-v1-module__4SqwjG__entryMethodBadge",
  "entryMethodCard": "choose-your-plan-v1-module__4SqwjG__entryMethodCard",
  "entryMethodCards": "choose-your-plan-v1-module__4SqwjG__entryMethodCards",
  "entryMethodContent": "choose-your-plan-v1-module__4SqwjG__entryMethodContent",
  "entryMethodHeading": "choose-your-plan-v1-module__4SqwjG__entryMethodHeading",
  "entryMethodList": "choose-your-plan-v1-module__4SqwjG__entryMethodList",
  "entryMethodSticker": "choose-your-plan-v1-module__4SqwjG__entryMethodSticker",
  "entryMethodStickerText": "choose-your-plan-v1-module__4SqwjG__entryMethodStickerText",
  "entryMethodTabPage": "choose-your-plan-v1-module__4SqwjG__entryMethodTabPage",
  "hero": "choose-your-plan-v1-module__4SqwjG__hero",
  "heroImageDesktop": "choose-your-plan-v1-module__4SqwjG__heroImageDesktop",
  "heroImageMobile": "choose-your-plan-v1-module__4SqwjG__heroImageMobile",
  "heroTrustBulletContainer": "choose-your-plan-v1-module__4SqwjG__heroTrustBulletContainer",
  "horizontalRule": "choose-your-plan-v1-module__4SqwjG__horizontalRule",
  "prizePlatformBulletContainer": "choose-your-plan-v1-module__4SqwjG__prizePlatformBulletContainer",
  "prizePlatformTitle": "choose-your-plan-v1-module__4SqwjG__prizePlatformTitle",
  "trustBulletList": "choose-your-plan-v1-module__4SqwjG__trustBulletList",
  "trustBulletListItem": "choose-your-plan-v1-module__4SqwjG__trustBulletListItem",
  "trustBulletListQuarterOnMobile": "choose-your-plan-v1-module__4SqwjG__trustBulletListQuarterOnMobile",
  "trustBulletListStackOnMobile": "choose-your-plan-v1-module__4SqwjG__trustBulletListStackOnMobile",
});
